import useEventListener from 'hooks/useEventListener'
import { memo, useEffect, useState } from 'react'
import { getBuildInfo } from './getBuildInfo'
import { insertBuildInfoComment } from './insertBuildInfoComment'
import config from '../../app/config'
import { useLocation } from 'react-router-dom'

const { isProd } = config()
export const BuildInfo = memo(() => {
  const location = useLocation()
  const [isVisible, setIsVisible] = useState(!isProd)

  const handleKeyDown = (event: KeyboardEvent) => {
    if (
      (event.metaKey || event.ctrlKey) &&
      event.shiftKey &&
      event.key === 'i'
    ) {
      setIsVisible((prevState) => !prevState)
    }
  }

  useEventListener('keydown', handleKeyDown, window)
  useEffect(() => {
    insertBuildInfoComment()
  }, [])

  const buildInfo = getBuildInfo(location.pathname)
  if (!buildInfo || !isVisible) return null

  const {
    appBuild,
    appBuildDate,
    appName,
    platformBuild,
    platformBuildDate,
    toolbarBuild,
    toolbarBuildDate,
  } = buildInfo

  return (
    <div className="pointer-events-none fixed bottom-3 right-3 z-50 mt-auto pb-0 pl-5 text-xs">
      <div>
        {appName}, {appBuild}, {appBuildDate}
      </div>
      <div>
        toolbar, {toolbarBuild}, {toolbarBuildDate}
      </div>
      <div>
        platform, {platformBuild}, {platformBuildDate}
      </div>
    </div>
  )
})

BuildInfo.displayName = 'BuildInfo'
